import { EmailTemplateI } from "../Types/state/emailTemplate.state";

// Reducer Types
export interface State {
	faqList: any;
	emailTemplateList: any;
	emailTemplateCount: any;
	emailTemplateDetails: any;
	singleEmailTemplate: any; // Replace `any` with a more specific type if available
}

interface EmailTemplateListSuccess {
	type: "EMAIL_TEMPLATE_LIST_SUCCESS";
	payload: { list: null | EmailTemplateI[]; count: number }; // Replace `any` with the actual data type if available
}

interface EmailTemplateDetailsSuccess {
	type: "EMAIL_TEMPLATE_DETAILS_SUCCESS";
	payload: any; // Replace `any` with the actual data type if available
}

interface ClearEmailTemplateDetails {
	type: "CLEAR_EMAIL_TEMPLATE_DETAILS";
}

interface SingleEmailTemplateSuccess {
	type: "SINGLE_EMAIL_TEMPLATE_SUCCESS";
	payload: any; // Replace `any` with the actual data type if available
}

type Action = EmailTemplateListSuccess | EmailTemplateDetailsSuccess | ClearEmailTemplateDetails | SingleEmailTemplateSuccess;

export const emailReducer = (
	state: State = {
		faqList: undefined,
		emailTemplateList: undefined,
		emailTemplateCount: undefined,
		emailTemplateDetails: undefined,
		singleEmailTemplate: undefined,
	},
	action: Action
): State => {
	switch (action.type) {
		case "EMAIL_TEMPLATE_LIST_SUCCESS":
			return {
				...state,
				emailTemplateList: action.payload.list,
				emailTemplateCount: action.payload.count,
			};
		case "EMAIL_TEMPLATE_DETAILS_SUCCESS":
			return {
				...state,
				emailTemplateDetails: action.payload,
			};
		case "CLEAR_EMAIL_TEMPLATE_DETAILS":
			return {
				...state,
				emailTemplateDetails: undefined,
			};
		case "SINGLE_EMAIL_TEMPLATE_SUCCESS":
			return {
				...state,
				singleEmailTemplate: action.payload,
			};
		default:
			return state;
	}
};
